import React from "react";
import {
  Container,
  FormWrap,
  Icon,
  FormContent,
  Form,
  FormH1,
  FormLabel,
  FormInput,
  FormButton,
  Text,
} from "../Signin/SigninElements";
// import {
//   ServicesContainer,
//   ServicesH1,
//   ServicesWrapper,
//   ServicesCard,
//   ServicesIcon,
//   ServicesH2,
//   ServicesP,
//   ServicesCardLink,
// } from "../Services/ServicesElements";

const Finance = () => {
  return (
    <>
      <Container>
        <FormWrap>
          <Icon to="/">Avastro$</Icon>
          {/* <ServicesCard>
          <ServicesIcon src={Icon2} />
          <ServicesH2>Retail & ECommerce</ServicesH2>
          <ServicesP>
            Keep the finger on your organization's financial pulse.
          </ServicesP>
        </ServicesCard> */}
          <FormContent>
            <Form action="#">
              <FormH1>Sign in to your account</FormH1>
              <FormLabel htmlFor="for">Email</FormLabel>
              <FormInput type="email" required />
              <FormLabel htmlFor="for">Password</FormLabel>
              <FormInput type="password" required />
              <FormButton type="submit">Continue</FormButton>
              <Text>Forget password</Text>
            </Form>
          </FormContent>
        </FormWrap>
      </Container>
    </>
  );
};

export default Finance;
